import React from 'react';
import styles from './Features.module.css';
import phone from '../assets/Phone.png';

function Features() {
  return (
    <section id="features" className={styles.features}>
      <h2 className={styles.sectionTitle}>KIPA’s funksjoner</h2>
      <p className={styles.info}>
        I utviklingen av KIPA har vi lagt vekt på enkelhet, tilgjengelighet og effektivitet.
        Hver funksjon er designet for å gjøre opplevelsen intuitiv og lett å bruke, slik at du får en løsning som passer deg og dine behov.
      </p>
      
      <div className={styles.content}>
        {/* Left Side Points */}
        <div className={styles.pointsLeft}>
          <div className={styles.point}>
            <span className={styles.circle}></span>
            <div>
              <h3>Responsivt design</h3>
              <p>KIPA er laget med responsivt design som automatisk tilpasser seg alle enheter, enten du bruker mobil, nettbrett.</p>
            </div>
          </div>
          <div className={styles.point}>
            <span className={styles.circle}></span>
            <div>
              <h3>Lastet med funksjoner</h3>
              <p>KIPA er full av smarte funksjoner som gjør hverdagen din enklere. Fra personlig tilpasning til avanserte verktøy.</p>
            </div>
          </div>
          <div className={styles.point}>
            <span className={styles.circle}></span>
            <div>
              <h3>Personlig brukerstøtte</h3>
              <p>Med KIPA får du mer enn bare en app – du får også personlig brukerstøtte når du trenger det.</p>
            </div>
          </div>
        </div>
        
        {/* Centered Phone Image */}
        <img src={phone} alt="Phone showing KIPA app features" className={styles.featureImage} />

        {/* Right Side Points (repeat the points if needed for symmetry or add unique ones) */}
        
      </div>
    </section>
  );
}

export default Features;
